const Reducer = (
  state = {
    assetEditData: {
      edit: false,
      data: {},
    },
    workOrderEditData: {
      edit: false,
      data: {},
    },
    workTypeData: {
      edit: false,
      data: {},
    },
    inventoryAdjustmentData: {
      edit: false,
      data: {},
    },
    pmEditData: {
      edit: false,
      data: {},
    },
    inspScheduleData: {
      edit: false,
      data: {},
    },
    workOrderData:[]
  },
  actions
) => {
  switch (actions.type) {
    case "assetEditData":
      return { ...state, assetEditData: actions.payload };
    case "woEditData":
      return { ...state, workOrderEditData: actions.payload };
      case "workType":
        return { ...state, workTypeData: actions.payload };
    case "pmEditData":
      return { ...state, pmEditData: actions.payload };
    case "inspScheduleData":
      return { ...state, inspScheduleData: actions.payload };
    case "inventoryAdjData":
      return { ...state, inventoryAdjustmentData: actions.payload };
    case "workOrderData":
        return { ...state, workOrderData: actions.payload };

    default:
      return state;
  }
};

export const formReducer = Reducer;
